import { render, staticRenderFns } from "./developmentProgress.vue?vue&type=template&id=b8747d98&"
import script from "./developmentProgress.vue?vue&type=script&lang=js&"
export * from "./developmentProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports